
import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";

import Item from "./AlertsItem";
import Button from "../../UI/Button/Button";

import { faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styles from "./Alerts.module.scss"; 

import LogService from "../../../middleware/CommonSdk/LogService";
const LOG_TAG = "Alerts";


const Bell = (props) => (
    <button className="btn btn-login btn-alert" disabled={props.disabled} title= "voir les notifications..."
        id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" >
        <FontAwesomeIcon icon={faBell} size="lg" focusable="true" />

        <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-white">
            {props.nbNew > 9? "9+": props.nbNew}
        </span>
    </button>   
)

const Alerts = (props) => {
    const intl = useIntl();

    function onDeleteItem(event, id) {
        LogService.info(LOG_TAG, "Delete item:" + id);
    };

    function onDeleteAll(event) {
        LogService.info(LOG_TAG, "Delete all items");
    }

    function onAcquittmentAlerts(event) {
        LogService.info(LOG_TAG, "Acquittment all new items");
    }

    //render
    //determine the nb of new alerts
    let nbNew = 1;
    
    //if there is alerts
    let hasAlerts = Object.keys(props.alerts).length;
    
    //if there is alerts and new alerts
    //let hasNew = hasAlerts > 0 && nbNew > 0;

    //if there is no alerts then the button is disabled
    let btnStatus = hasAlerts === 0 ? " disabled" : "";
        
    //define the item link
    let alertLink = (type) => {
        switch (type) {
            case "application":
                return "/application"
            case "invoices":
                return "/billing"
            case "billing":
                return "/billing"
            case "sandbox":
                return "/sandbox"
            case "error":
                return ""     
            default:
                return "" 
        }
    }

    let listItems = props.alerts.map(alert => (
        <li className="p-0" id={alert.id} key={`alerts-${alert.id}`}>
            <Item
                title={alert.title}
                message={alert.message}
                date={alert.date}
                status={alert.status}
                to={alertLink(alert.type)}
                onClick={(e, id) => onDeleteItem(e, alert.id)}
            />
        </li>
    ));

    return (
        <div className="mr-3 dropdown" data-toggle="tooltip">
            <Bell 
                nbNew={nbNew} 
                disabled={btnStatus}
                onClick={(e) => onAcquittmentAlerts(e)} 
            />
            
            <div className={styles.alertsMenuContainer + " dropdown-menu"} aria-labelledby="dropdownMenu1">
                <div className="d-flex border-bottom border-light">
                    <h5 className="text-uppercase">{intl.messages.alertTitle}</h5>
                    <span className="ml-auto">
                        <Button 
                            className="btn btn-link"
                            label={intl.messages.deleteAll}
                            onClick={(e) => onDeleteAll(e)}                            
                        />
                    </span> 
                </div>
                    
                <ul className={styles.alertsMenuBody}>
                    {listItems}
                </ul>

            </div>
        </div>
    );
}

Alerts.defaultProps = {
    alerts: [
        { id: "1", type: "sandbox", title: "Cant create a sandbox account", message: "Your Rainbow account is not yet initialized. To be able to create your sandbox account, please complete the Rainbow account initialization wizard", date: "2021 April 08, 5:24 pm", status:"new" },
        { id: "2", type: "invoices", title: "Invoices", message: "New invoices receives.", date: "2021 April 08, 5:24 pm", status:"" },
        { id: "3", type: "application", title: "Certificate has expired", message: "Saxa lapidum interius saxa interius se et pinnis et portarum.", date: "2021 April 08, 5:24 pm", status:"" },
        { id: "4", type: "application", title: "Quota exceeded", message: "Et organa tinnitu levia ignaviae cultibus domus exundant pro ludicrarum organa accitur ignaviae levia sit.", date: "2021 April 08, 5:24 pm", status:"" }
    ]
}

Alerts.propTypes = {
    alerts: PropTypes.array,
    error: PropTypes.object,
    progress: PropTypes.bool,
}

export default Alerts;